module.exports = require("./ar-TN.d.ts");